import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/Tumi/TumiLogo.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "TumiBackLogin"
}
const _hoisted_3 = { class: "TumiLogin" }
const _hoisted_4 = { class: "TumiForm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "LogoTumi",
  class: "mb-5"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-5" }, "Choose a new password.", -1)
const _hoisted_7 = { class: "d-grid gap-2" }
const _hoisted_8 = { class: "TumiErrorLogin mt-3" }
const _hoisted_9 = { class: "TumiTextWarning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.start || _ctx.criticalError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.criticalError), 1))
      : _createCommentVNode("", true),
    (_ctx.start && !_ctx.criticalError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _hoisted_5,
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pass) = $event)),
                  placeholder: "New password"
                }, null, 512), [
                  [_vModelText, _ctx.pass]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pass2) = $event)),
                  placeholder: "Repeat password"
                }, null, 512), [
                  [_vModelText, _ctx.pass2]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SetNewPass && _ctx.SetNewPass(...args))),
                    class: "btn btn-primary"
                  }, "Set new pass")
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.error), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}